var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDarkClose = function SvgDarkClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 15.5,
    transform: "matrix(-1 0 0 1 16 16)",
    stroke: "#17181D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 21.25 21.25 10l.75.75L10.75 22l-.75-.75Z",
    fill: "#17181D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 22 10 10.75l.75-.75L22 21.25l-.75.75Z",
    fill: "#17181D"
  })));
};
export { SvgDarkClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSByPSIxNS41IiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSAxNiAxNikiIHN0cm9rZT0iIzE3MTgxRCIvPgo8cGF0aCBkPSJNMTAgMjEuMjVMMjEuMjQ5MiAxMEwyMS45OTkxIDEwLjc1TDEwLjc0OTkgMjJMMTAgMjEuMjVaIiBmaWxsPSIjMTcxODFEIi8+CjxwYXRoIGQ9Ik0yMS4yNSAyMkwxMC4wMDA4IDEwLjc1TDEwLjc1MDggMTBMMjEuOTk5OSAyMS4yNUwyMS4yNSAyMloiIGZpbGw9IiMxNzE4MUQiLz4KPC9zdmc+Cg==";